require('./l-1-visa.scss');

$(() => {
    $('.side_menu_item').on('click', function() {
        change_page( $(this).data('page'), this)
    })

    function change_page(page, elem){
        jQuery('.right_menu').each(function (index, elem){
            jQuery(elem).addClass('d-none');
        });
    
        jQuery('#right_menu_' + page).removeClass('d-none');
        
        jQuery('.side_menu_item').each(function (index, elem){
            jQuery(elem).removeClass('active');
        });
        
        jQuery('#side_menu_' + page).addClass('active');
        
        jQuery('.content-page:not(.static)').each(function (index, elem){
            jQuery(elem).addClass('d-none');
        });
        
        jQuery('#page_' + page).removeClass('d-none');
    
        // When it_slide_pages exists
        if( jQuery("#current-page") ) {
            jQuery("#current-page").val(`${page-1}`);
            jQuery("#counter_page").html(`${page}`);
            
            if(jQuery('.content-page:not(.static)').length == page) {
                jQuery("#next_page").prop("disabled", true);
                jQuery("#previous_page").prop("disabled", false);
            }
            else if(page -1  == 0) {
                jQuery("#previous_page").prop("disabled", true);
                jQuery("#next_page").prop("disabled", false);
            }
            else {
                jQuery("#previous_page").prop("disabled", false);
                jQuery("#next_page").prop("disabled", false);
            }
        }
    }

    $('.slide-arrow').on('click', function() {
        slide_page( $(this).data('direction'))
    })
    
    window.slide_page = function(direction) {
        let currentPage = parseInt( jQuery("#current-page").val());
        let selectors = jQuery('.slider-selectors .side_menu_item');
        let pages = jQuery('.content-page:not(.static)');
        let moved = false;
    
        for (let i = 0; i < (pages.length || selectors.length); i++) {
            jQuery(selectors[i]).removeClass('active');
            jQuery(pages[i]).addClass('d-none');
    
            if(direction < 0 && !moved) { //Go to previous page
                if(currentPage == i + 1) { 
                    jQuery(selectors[i]).addClass('active');
                    jQuery(pages[i]).removeClass('d-none');
                    jQuery("#current-page").val(`${i}`);
                    jQuery("#counter_page").html(`${i+1}`);
                    moved = true;
                } 
            }   
            else if(direction > 0 && !moved) { //Go to next page
                if(currentPage + 1 == i) { 
                    jQuery(selectors[i]).addClass('active');
                    jQuery(pages[i]).removeClass('d-none');
                    jQuery("#current-page").val(`${i}`);
                    jQuery("#counter_page").html(`${i+1}`);
                    moved = true;
                } 
            }
        }
    
        if(pages.length == currentPage + 2 && direction > 0) {
            jQuery("#next_page").prop("disabled", true);
        }
        else if(currentPage - 1 == 0 && direction < 0) {
            jQuery("#previous_page").prop("disabled", true);
        }
        else {
            jQuery("#previous_page").prop("disabled", false);
            jQuery("#next_page").prop("disabled", false);
        }
    }
});